export function StatusBadge({ status }: { status: string }) {
  const colorClass = {
    active: 'green',
    pending: 'yellow',
    paused: 'orange',
    deleted: 'red',
  }[status] || 'gray';

  return <span className={`status-badge ${colorClass}`}>{status}</span>;
}
